export const STORE_AUTH = 'STORE_AUTH';